import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';
import localeUtils from 'utils/LanguageLocale';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+SKU+Detail+API

function getReverseLookUpSkuDetails(skuId) {
    let url = `/api/catalog/skus/${skuId}`;
    const queryParams = [];

    if (cookieUtils.isPXSEnabled()) {
        url = '/api/v3/catalog/skus/' + skuId;
        const countryCode = localeUtils.getCurrentCountry();
        const languageCode = localeUtils.getCurrentLanguageCountryCode().replace('_', '-');
        queryParams.push(`?countryCode=${countryCode}&loc=${languageCode}`);
    }

    url = url + queryParams.join('&');

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getReverseLookUpSkuDetails;
